import * as m from "../../model/model";

import { CCourse } from "./CCourse";
/**
 * This is complete data on each course from Airtable.
 * Tutorings are injected from Webflow.
 * Used as read-only.
 */
import { CoursesResponse } from "../../api/api-model";

export class CCourses {
  json: CoursesResponse;
  courses: CCourse[] = [];
  tutorings: m.Tutoring[] = [];

  constructor(json: CoursesResponse) {
    this.json = json;
    this.parse(json);
  }

  parse(json: CoursesResponse) {
    this.courses = (json.courses || []).map(
      (course: m.Course) => new CCourse(course)
    );
    this.tutorings = json.tutorings;
  }

  get names() {
    return this.courses.map((course: CCourse) => course.name);
  }

  get uids() {
    return this.courses.map((course: CCourse) => course.uid);
  }

  getCourse(uid?: string) {
    return this.courses.find((course) => course.uid === uid);
  }

  getTutoring(uid: string) {
    return this.tutorings.find((tutoring: m.Tutoring) => tutoring.uid === uid);
  }
}
